import React, { lazy } from "react";
import SocialButtons from "@/components/refactored/header/top-bar/social-buttons";
import TickerData from "@/components/ticker-data/tickerdata";

const TopBar = ({ ...props }) => {
  return (
    <div className={"bg-metaxseed-blue-darker w-full py-2"}>
      <div 
        className={"xl:container mx-auto bg-metaxseed-blue-darker flex flex-row items-center justify-between"} 
        {...props}
      >
        <div className={"px-4 sm:px-6 lg:px-8 xl:px-0"}>
          <SocialButtons />
        </div>
        <div className={"flex-grow flex justify-end"}>
          <TickerData />
        </div>
      </div>
    </div>
  );
};

export default TopBar;